

import { combineReducers } from 'redux';
import videosSlider from './videosSliderReducer';
import videosPage from './videosReducer';

// if there are more than one reducer in this component, use combineReducers:

const videos = combineReducers({
    videosSlider,
    videosPage,
});

export default videos;
